import {
  createUnifiedTheme,
  UnifiedThemeProvider,
  palettes,
  genPageTheme,
  shapes,
} from '@backstage/theme';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import LightIcon from '@material-ui/icons/WbSunny';
import DarkIcon from '@material-ui/icons/Brightness2';

const cfgLightTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: {
      main: '#1a1a1a',
    },
    secondary: {
      main: '#e8564a',
    },
    navigation: {
      background: '#1a1a1a',
      color: '#f5f5f5',
      indicator: '#e8564a',
      selectedColor: '#ffffff',
      navItem: {
        hoverBackground: 'rgba(255,255,255,0.08)',
      },
    },
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
    },
  },
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: ['#1a1a1a', '#333333'], shape: shapes.wave }),
    tool: genPageTheme({ colors: ['#1a1a1a', '#333333'], shape: shapes.round }),
    documentation: genPageTheme({ colors: ['#1a1a1a', '#333333'], shape: shapes.wave2 }),
    service: genPageTheme({ colors: ['#1a1a1a', '#333333'], shape: shapes.round }),
    website: genPageTheme({ colors: ['#1a1a1a', '#333333'], shape: shapes.wave }),
    library: genPageTheme({ colors: ['#1a1a1a', '#333333'], shape: shapes.wave2 }),
    other: genPageTheme({ colors: ['#1a1a1a', '#333333'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#1a1a1a', '#333333'], shape: shapes.wave }),
  },
  fontFamily: '"Rethink Sans", "Helvetica Neue", Arial, sans-serif',
  components: {
    BackstageSidebar: {
      styleOverrides: {
        drawer: {
          background: '#1a1a1a',
        },
      },
    },
    BackstageHeader: {
      styleOverrides: {
        header: {
          backgroundImage: 'linear-gradient(90deg, #1a1a1a, #333333)',
          boxShadow: 'none',
        },
      },
    },
  },
});

const cfgDarkTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    primary: {
      main: '#e0e0e0',
    },
    secondary: {
      main: '#e8564a',
    },
    navigation: {
      background: '#111111',
      color: '#f5f5f5',
      indicator: '#e8564a',
      selectedColor: '#ffffff',
      navItem: {
        hoverBackground: 'rgba(255,255,255,0.08)',
      },
    },
  },
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: ['#111111', '#222222'], shape: shapes.wave }),
    tool: genPageTheme({ colors: ['#111111', '#222222'], shape: shapes.round }),
    documentation: genPageTheme({ colors: ['#111111', '#222222'], shape: shapes.wave2 }),
    service: genPageTheme({ colors: ['#111111', '#222222'], shape: shapes.round }),
    website: genPageTheme({ colors: ['#111111', '#222222'], shape: shapes.wave }),
    library: genPageTheme({ colors: ['#111111', '#222222'], shape: shapes.wave2 }),
    other: genPageTheme({ colors: ['#111111', '#222222'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#111111', '#222222'], shape: shapes.wave }),
  },
  fontFamily: '"Rethink Sans", "Helvetica Neue", Arial, sans-serif',
});

export const cfgLight = ThemeBlueprint.make({
  name: 'cfg-light',
  params: {
    theme: {
      id: 'cfg-light',
      title: 'Code for Good Light',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={cfgLightTheme}>{children}</UnifiedThemeProvider>
      ),
    },
  },
});

export const cfgDark = ThemeBlueprint.make({
  name: 'cfg-dark',
  params: {
    theme: {
      id: 'cfg-dark',
      title: 'Code for Good Dark',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={cfgDarkTheme}>{children}</UnifiedThemeProvider>
      ),
    },
  },
});
